import type { IAccountTransaction } from "@/modules/account/common/types";
import { CURRENCY } from "@/shared/common/constants";
import { Currencies, TransactionDirection, UiType } from "@/shared/common/enums";
import { formatDate } from "@/shared/helpers";
import type { ICellProps } from "@ab.uitools/ui-library/components/AdvancedTable/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  t: (s: string) => string;
}

export const getColumns = ({ t }: Props) => ([
  {
    id: "operation_date",
    header: t("accounts.historyTable.date"),
    accessorKey: "operationDate",
    enableHiding: false,
    cell: ({ row }: ICellProps<IAccountTransaction>) => {
      const date = formatDate(row.original?.operationDate);
      return (
        <Text>{date}</Text>
      );
    }
  },
  {
    id: "transaction_group_type",
    header: t("accounts.historyTable.transactionType"),
    accessorKey: "transactionGroupType",
    cell: ({ row }: ICellProps<IAccountTransaction>) => {
      const transactionGroupType = row.original?.transactionGroupType;
      return (
        <Text>{t(`transactionGroupTypes.${transactionGroupType}`)}</Text>
      );
    },
  },
  {
    id: "transaction_number",
    header: t("accounts.historyTable.transactionNumber"),
    accessorKey: "documentNumber",
    enableHiding: false,
  },
  {
    id: "account",
    header: t("accounts.historyTable.account"),
    accessorKey: "senderAccount",
    enableHiding: false,
  },
  {
    id: "payer_beneficiary",
    header: t("accounts.historyTable.payerBeneficiary"),
    accessorKey: "sender",
    cell: ({ row }: ICellProps<IAccountTransaction>) => {
      return (
        <Text className="truncate-2-lines">{row.original.sender}</Text>
      );
    }
  },
  {
    id: "aim",
    header: t("accounts.historyTable.aim"),
    accessorKey: "description",
    cell: ({ row }: ICellProps<IAccountTransaction>) => {
      return (
        <div className="truncate">
          <Text>{row.original?.description}</Text>
        </div>
      );
    }
  },
  {
    id: "enter_exit",
    header: t("accounts.historyTable.enterExit"),
    accessorKey: "convertedAmount",
    enableHiding: false,
    cell: ({ row }: ICellProps<IAccountTransaction>) => {
      const amount = row.original?.convertedAmount;
      const currency = row.original?.currency;
      const type = row.original?.transactionDirection === TransactionDirection.In ?
        UiType.Success : UiType.Danger;
      const symbol = type === UiType.Success ? "+" : "-";
      return (
        <Text type={type}>{`${symbol}${amount} ${CURRENCY[currency]?.symbol}`}</Text>
      );
    },
  },
  {
    id: "equivalent_in_AMD",
    header: t("accounts.historyTable.equivalentInAMD"),
    accessorKey: "amount",
    cell: ({ row }: ICellProps<IAccountTransaction>) => {
      const amount = row.original?.amount;
      const type = row.original?.transactionDirection === TransactionDirection.In ?
        UiType.Success : UiType.Danger;
      const symbol = type === UiType.Success ? "+" : "-";
      return (
        <Text type={type}>{`${symbol}${amount} ${CURRENCY[Currencies.AMD]?.symbol}`}</Text>
      );
    },
  }
]);
